/**
 * App Header Component
 */

import React from 'react'
import { Layout, Typography, Space } from 'antd'
import { GlobalOutlined } from '@ant-design/icons'

const { Header } = Layout
const { Title } = Typography

const AppHeader: React.FC = () => {
  return (
    <Header
      style={{
        display: 'flex',
        alignItems: 'center',
        background: '#001529',
        padding: '0 24px',
      }}
    >
      <Space>
        <GlobalOutlined style={{ fontSize: 24, color: '#1890ff' }} />
        <Title level={3} style={{ margin: 0, color: '#fff' }}>
          Commercial Admin Portal
        </Title>
      </Space>
    </Header>
  )
}

export default AppHeader

